export const filterPersistedState = <T extends Record<string, any>>(
  state: Partial<T>,
  config: Record<string, boolean | Record<string, any>>,
): Partial<T> => {
  const filteredState: Partial<T> = {};

  Object.keys(config).forEach((key) => {
    if (config[key] === true) {
      if (key in state) {
        filteredState[key as keyof T] = state[key as keyof T];
      }
    } else if (typeof config[key] === 'object' && key in state) {
      const nestedState = state[key as keyof T] as Record<string, any>;
      const nestedConfig = config[key] as Record<string, any>;

      filteredState[key as keyof T] = filterPersistedState(
        nestedState,
        nestedConfig,
      ) as T[keyof T];
    }
  });

  return filteredState;
};
